import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/OfferTable/GET';

export const OFFER_TABLE_GET_SUCCESS = `${rootActionPath}_${SUCCESS_SUFFIX}`;
export const OFFER_TABLE_GET_FAILURE = `${rootActionPath}_${FAILURE_SUFFIX}`;
export const OFFER_TABLE_VIEWED = `${rootActionPath}/VIEWED`;
